import { render } from "./equipmentsComponent.vue?vue&type=template&id=fe63ddf4"
import script from "./equipmentsComponent.vue?vue&type=script&lang=js"
export * from "./equipmentsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__